import { AxiosResponse } from 'axios';
import { api } from '../api';
import { GenericDeleteResponse, StandardResponse } from '../interfaces/Common';
import { PartialTermFormRequest, Term, TermFormRequest } from '../interfaces/Terms';

export async function getTerms(params?: { keyword?: string; status?: string }): Promise<StandardResponse<Term[]>> {
    const response: AxiosResponse<StandardResponse<Term[]>> = await api.get("/terms", {
        params
    });
    return response.data;
}

export async function createTerm(request: TermFormRequest): Promise<StandardResponse<Term>> {
    const response: AxiosResponse<StandardResponse<Term>> = await api.post("/terms", request);
    return response.data;
}

export async function updateTerm(termId: string, request: PartialTermFormRequest): Promise<StandardResponse<Term>> {
    const response: AxiosResponse<StandardResponse<Term>> = await api.put(`/terms/${termId}`, request);
    return response.data;
}

export async function deleteTerm(termId: string): Promise<StandardResponse<GenericDeleteResponse>> {
    const response: AxiosResponse<StandardResponse<GenericDeleteResponse>> = await api.delete(`/terms/${termId}`);
    return response.data;
}